import { Button } from "@mui/material";

/** , をOR式の中で安全に扱うため */
const escCommas = (s) => String(s || "").replace(/,/g, "\\,");

// 共通：ISO/Date を “YYYY-MM-DD hh:mm:ss” っぽく
const fmtTs = (v) => {
  if (!v) return "";
  const s = String(v);
  return s.slice(0, 19).replace("T", " ");
};

const journalsPlugin = {
  debugTag: "Journals",
  table: "journals",

  // PostgREST にはコメント禁止。列名だけ。
  select: "id,name_eng,name_org,issn,publisher,created_at,last_update",

  // name_eng があればそれで昇順
  defaultSort: { field: "name_eng", sort: "asc" },

  // 取得した行を “表示にそのまま使える形” に正規化して返す
  normalize(r) {
    return {
      ...r,
      // ← DataGrid がそのまま読むフィールドを追加（valueGetter 不要にする）
      name: r.name_eng || r.name_org || "(no name)",
      original_name: r.name_org || "",
      updated_like: r.last_update || r.created_at || null,
      updated_like_text: fmtTs(r.last_update || r.created_at || null),
    };
  },

  // PostgREST の or 検索式
  or(search) {
    if (!search) return undefined;
    const like = `%${escCommas(search)}%`;
    return [
      `name_eng.ilike.${like}`,
      `name_org.ilike.${like}`,
      `issn.ilike.${like}`,
      `publisher.ilike.${like}`,
    ].join(",");
  },

  // DataGrid 列定義（全部 “行の素フィールド” を読む）
  columns({ onEdit }) {
    return [
      {
        field: "__actions",
        headerName: "Actions",
        width: 96,
        sortable: false,
        filterable: false,
        renderCell: (p) =>
          p?.row ? (
            <Button size="small" variant="outlined" onClick={() => onEdit?.(p.row)}>
              Edit
            </Button>
          ) : null,
        headerClassName: "col-actions",
        cellClassName: "col-actions",
      },
      {
        field: "name",
        headerName: "Name",
        flex: 1.4,
        minWidth: 260,
      },
      {
        field: "original_name",
        headerName: "Original Name",
        flex: 1.2,
        minWidth: 240,
      },
      { field: "issn", headerName: "ISSN", width: 160 },
      { field: "publisher", headerName: "Publisher", width: 220 },
      {
        field: "updated_like_text",
        headerName: "Updated",
        width: 170,
      },
      { field: "id", headerName: "UUID", width: 360 },
    ];
  },
};

export default journalsPlugin;
export { journalsPlugin };
